import { resetAuthSessionCache } from '@/core/hooks/auth-session-cache';
import { queryClient } from '@/core/providers/query-provider';
import { useWorkspaceStore } from '@/core/store/workspace.store';

const AUTH_RETURN_URL_KEY = 'authReturnUrl';

/**
 * Clears user/session caches without logging out of auth store.
 * Called from performFullLogout after auth tokens are cleared.
 */
export function resetSessionCaches() {
  queryClient.clear();
  resetAuthSessionCache();
  useWorkspaceStore.getState().clearWorkspace();
  sessionStorage.removeItem(AUTH_RETURN_URL_KEY);
}
